import {store} from './Store';
import {useOrderHistoryStore} from "./OrderHistory";
import {Order} from "../types";
import {BigNumber} from "bignumber.js";
import {getSiweJwt, jwtsAreValid, signOutAndClearJWT} from "../lib/SiweClient";

export async function reloadHistoryFromApi() {
    if (jwtsAreValid()) {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getSiweJwt()
            }
            const request: Request = new Request(store.config.orderHistory, {
                method: "GET",
                headers: headers
            });
            const res: Response = await fetch(request);
            try {
                const orderHistory = useOrderHistoryStore();
                const fetchedOrders = (await res.json()).orders;
                console.log("Fetched orders", fetchedOrders);
                fetchedOrders.forEach((fetchedOrder) => {
                    const orderToStore: Order = {
                        buyingAsset: fetchedOrder.buyingAsset,
                        sellingAsset: fetchedOrder.sellingAsset,
                        limitAmount: new BigNumber(fetchedOrder.limitAmount),
                        chainOrderSource: {
                            orderSource: fetchedOrder.orderSource,
                            smartContractAddress: "unknown"
                        },
                        quantityBought: new BigNumber(fetchedOrder.quantityBought),
                        quantitySold: new BigNumber(fetchedOrder.quantitySold),
                        feePaid: new BigNumber(fetchedOrder.feePaid),
                        placeTransactionId: fetchedOrder.placeTransactionId || fetchedOrder.instructionId,
                        settleTransactionId: fetchedOrder.returnTxId,
                        status: fetchedOrder.status,
                        timestamp: parseInt(fetchedOrder.timestampMillis)
                    }
                    orderHistory.upsertOrder(orderToStore);
                });
                store.loadedOrderHistory = true
            }
            catch (e) {
                console.log('loadHistory error', e);
                if (e.toString().indexOf('Unauthorized') > 0) {
                    signOutAndClearJWT("Unauthorised order history request");
                }
            }
        }
        catch (error) {
            store.tokenStatus = 'Error! Could not reach the API ' + error
            console.log('historyData error', store.tokenStatus);
        }
    }
}
